/**
 * 名簿の画面で使う言葉（運用される方が読む名前）。
 *
 * 値そのものの定義元はサーバ（`server/src/users/member-service.ts`）。ここはその**言い換え**だけ。
 * 表に無い値が来ても画面は壊さず、受け取った値をそのまま出す。
 */
import type { MemberStatus } from '../api/types.js';
import { formatDateTime as formatDateTimeShared } from '../format/datetime.js';

const STATUS_LABELS: Record<MemberStatus, string> = {
  invited: 'ログイン前',
  active: '利用中',
  deactivated: '無効',
};

export function memberStatusLabel(status: string): string {
  return STATUS_LABELS[status as MemberStatus] ?? status;
}

/** 在籍状態の説明（1行）。「ログイン前」だけでは何が起きているか分からないため。 */
const STATUS_NOTES: Record<MemberStatus, string> = {
  invited: 'メンバーとして登録されていて、まだログインしていない方です。',
  active: 'いまお使いいただいている方です。',
  deactivated: 'ログインできません。トークの中身も見えません。',
};

export function memberStatusNote(status: string): string {
  return STATUS_NOTES[status as MemberStatus] ?? '';
}

/**
 * 雇用区分の言い換え。
 *
 * 呼び方は会社ごとに違うので、**CSVでいただいた言葉はそのまま出します**（docs/01 5-2）。
 * 言い換えるのは、まだ何も入れていない方に入る**こちらの既定値だけ**です
 * （そのままだと画面に英語の記号が出てしまうため）。
 */
const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
  regular: '社員',
};

export function employmentTypeLabel(value: string): string {
  return EMPLOYMENT_TYPE_LABELS[value] ?? value;
}

/** 日時の表し方（年月日と時分）。形は全画面で同じ（format/datetime.ts）。 */
export function formatDateTime(iso: string | null): string {
  return formatDateTimeShared(iso, '');
}
